// extracted by mini-css-extract-plugin
export default {"container":"AboutPage_container__DHJzJ","imgWrap":"AboutPage_imgWrap__WpvQi","content":"AboutPage_content__69pgZ"};